import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { TooltipProvider } from '@/components/ui/tooltip'
import CookieBanner from '@/components/CookieBanner'
import Home from '@/pages/home/Index'
import MentionsLegales from '@/pages/MentionsLegales'

export default function App() {
  return (
    <Router>
      <TooltipProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
        <Toaster />
        <CookieBanner />
      </TooltipProvider>
    </Router>
  )
}
